import React, { useEffect, useState } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  PaymentRequestButtonElement
} from "@stripe/react-stripe-js";
import Skeleton from "@mui/material/Skeleton";
import { RadioGroup, FormControlLabel, Radio, Box, Typography } from "@mui/material";

interface OnlinePaymentSectionProps {
  isOnlinePaymentChecked: boolean;
  isCheckingPaymentSupport: boolean;
  paymentErrorMessage?: string | null;
  isAppleGooglePayAvailable: boolean;
  appleGooglePayRequest?: any;
  isPaymentProcessing: boolean;
  paymentMethod: "wallet" | "card";
  setPaymentMethod: (method: "wallet" | "card") => void;
}

const OnlinePaymentSection: React.FC<OnlinePaymentSectionProps> = ({
  isOnlinePaymentChecked,
  isCheckingPaymentSupport,
  paymentErrorMessage,
  isAppleGooglePayAvailable,
  appleGooglePayRequest,
  isPaymentProcessing,
  paymentMethod,
  setPaymentMethod
}) => {


  useEffect(() => {
    if (isAppleGooglePayAvailable) {
      setPaymentMethod("wallet");
    } else {
      setPaymentMethod("card");
    }
  }, [isAppleGooglePayAvailable]);

  if (!isOnlinePaymentChecked) return null;

  return (
    <div style={{
      margin: "0 auto", 
      padding: "10px",
      border: "1px solid #ccc",
      backgroundColor: "#fff",
      borderRadius: "10px",
      width: "100%",
      // boxShadow: "0 2px 4px rgba(0,0,0,0.3)"
    }}>

      {/* <p className="block-title">
        Mode de paiement
      </p> */}

      {/* Payment Method Selection */}
      <RadioGroup
        row
        value={paymentMethod}
        onChange={(e) => setPaymentMethod(e.target.value as "wallet" | "card")}
        sx={{ mb: 3 }}
      >
        {isAppleGooglePayAvailable && (
          <FormControlLabel value="wallet" control={<Radio />} label="Paiement rapide" />
        )}
        <FormControlLabel value="card" control={<Radio />} label="Carte Bancaire" />
      </RadioGroup>

      {/* Loading Skeleton for wallet */}
      {isCheckingPaymentSupport && paymentMethod === "wallet" && (
        <Box sx={{ display: "flex", gap: 2 }}>
          <Skeleton
            variant="rectangular"
            width={250}
            height={44}
            sx={{ borderRadius: 1, bgcolor: "grey.300" }}
          />
          <Skeleton
            variant="rectangular"
            width={250}
            height={44}
            sx={{ borderRadius: 1, bgcolor: "grey.300" }}
          />
        </Box>
      )}

      {/* Error Message */}
      {paymentErrorMessage && (
        <Typography color="error" sx={{ mt: 1 }}>
          {paymentErrorMessage}
        </Typography>
      )}

      {/* Wallet Section */}
      {paymentMethod === "wallet" && isAppleGooglePayAvailable && appleGooglePayRequest && !isCheckingPaymentSupport && (
        <Box sx={{ mt: 2 }}>
          <PaymentRequestButtonElement
            options={{
              paymentRequest: appleGooglePayRequest,
              style: {
                paymentRequestButton: {
                  type: "default",
                  theme: "dark",
                  height: "44px",
                },
              },
            }}
          />
          {isPaymentProcessing && <Typography sx={{ mt: 1 }}>Traitement du paiement…</Typography>}
        </Box>
      )}

      {/* Credit Card Section */}
      {paymentMethod === "card" && (
        <Box sx={{ mt: 3 }}>

          <label htmlFor="card-number" style={{ display: "block", marginBottom: 4 }}>
            Numéro de carte
          </label>
          <div className="card-number card-info" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "6px", marginBottom: "16px" }}>
            <CardNumberElement id="card-number" options={{ showIcon: true }} />
          </div>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Box sx={{ flex: 1 }}>
              <label htmlFor="card-expiry" style={{ display: "block", marginBottom: 4 }}>
                Date d’expiration
              </label>
              <div className="card-info" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "6px" }}>
                <CardExpiryElement id="card-expiry" />
              </div>
            </Box>

            <Box sx={{ flex: 1 }}>
              <label htmlFor="card-cvc" style={{ display: "block", marginBottom: 4 }}>
                CVC
              </label>
              <div className="card-info" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "6px" }}>
                <CardCvcElement id="card-cvc" />
              </div>
            </Box>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default OnlinePaymentSection;
